module.exports = __webpack_public_path__ + "static/booch2-a8254cd5ae522146fb2b80379e45ef0f.jpg";